import request from '@/CommonDP/utils/request';

export default {
  queryGroupList(enterpriseId) {
    return request.get(`/printNameRule/get/group`, { params: { enterpriseId }})
      .then(res => res);
  },
  addGroup(areaName, enterpriseId) {
    return request.get(`/printNameRule/set/group`, { params: { areaName, enterpriseId }})
      .then(res => res);
  },
  updateGroup(areaName, id, enterpriseId) {
    return request.get('/printNameRule/update/group/name', { params: { id, areaName, enterpriseId }})
      .then(res => res);
  },
  delGroup(id) {
    return request.get('/printNameRule/del/group/name', { params: { id }})
      .then(res => res);
  },
  queryRuleDic (enterpriseId) {
    return request.get(`/printNameRule/get/frame`, { params: { enterpriseId }});
  },
  querySplitDic() {
    return request.get(`/printNameRule/get/cut`);
  },
  queryRoleList(areaId) {
    return request.get(`/printNameRule/get/name/role/back`, { params: { areaId }});
  },
  addRule (params) {
    return request.post(`/printNameRule/set/name/role`, params);
  }
};
